/**
 * DepartmentMenu
 *
 * Add behaviors to toggle the primary navigation dropdowns
 */
class DepartmentMenu {
  constructor() {
    this.departmentMenu = document.querySelector('.js--department-menu');

    this.bindEvents();
  }

  bindEvents() {
    this.departmentMenu.addEventListener('change', () => this.onMenuOptionChange());
  }

  onMenuOptionChange = () => {
    // Get the selected option
    const selectedOption = this.departmentMenu.selectedOptions[0];

    // Get the URL from the data attribute of the selected option
    const url = selectedOption.dataset.url;

    if (url) {
      // Redirect to the URL
      window.location.href = url;
    }
  };
}

export default DepartmentMenu;
